import React from "react";
import ScrollToTop from "../Component/ScrollToTop";

const ShippingPolicy = () => {
  return (
    <>
      <ScrollToTop />

      {/* HERO SECTION */}
      <section className="bg-light py-5">
        <div className="container text-center">
          <h1 className="fw-bold mb-2">Shipping Policy</h1>
          <p className="text-muted fs-5">
            Everything you need to know about our delivery process
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="container my-5">
        <div className="row justify-content-center">
          <div className="col-lg-9">

            <div className="card shadow-sm border-0 rounded-4 p-4">

              <h4 className="fw-semibold mb-3">🚚 Delivery Coverage</h4>
              <p>
                FreshCart currently delivers groceries and daily essentials
                to selected locations. Availability depends on your area and
                nearby store coverage.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">⏱ Delivery Time</h4>
              <p>
                Orders are usually delivered within <strong>10–60 minutes</strong>.
                Delivery time may vary due to traffic, weather conditions,
                or product availability.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">💰 Shipping Charges</h4>
              <p>
                Shipping charges (if any) are clearly shown at checkout before
                placing your order. Free delivery may be available during
                promotional periods.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">📦 Order Processing</h4>
              <p>
                Orders are processed immediately after confirmation. Once an
                order is packed or out for delivery, it cannot be modified
                or cancelled.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">❌ Missed Delivery</h4>
              <p>
                If delivery cannot be completed due to incorrect address,
                unavailability of the customer, or contact issues, the order
                may be cancelled without a refund.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">🔄 Delays & Exceptions</h4>
              <p>
                FreshCart is not responsible for delays caused by events beyond
                our control, including natural disasters, strikes, or
                unforeseen circumstances.
              </p>

              <hr />

              <h4 className="fw-semibold mb-3">📞 Customer Support</h4>
              <p className="mb-0">
                For any shipping-related queries, please contact our support
                team at <strong>+91 7856000970</strong> or visit the Contact page.
              </p>

            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default ShippingPolicy;